/**
 * A free offer for SIAE gating: price 0 — and an empty/unset price string, since an offer with no
 * positive price can't be SIAE-approved or accept Carta Cultura. Shared by the UI freeze
 * (`admission-form.tsx`) and the save coercion (`to-backend.ts`) so the two can't drift apart.
 *
 * Intentionally NOT the same as the add-ons "is free" check (`Number.parseFloat(price) === 0`),
 * which leaves an empty price as not-free — that divergence is by design and out of scope here.
 */
export const isFreeOfferPrice = (price: string | undefined): boolean => price === undefined || Number(price) === 0;
